import { createRouter, createWebHistory } from 'vue-router';
import { dispatchByParam } from './dispatchByParam.js';
import { getClubForParam } from './getClubForParam.js';
import { isAuthenticated } from '@langlois/vue-router-is-authenticated';
import { isAuthorized } from './isAuthorized.js';
import { routes } from './routes/index.js';
import { store } from '@/store/index.js';

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});

const authSearchParams = new URLSearchParams({
	clientId: process.env.VUE_APP_AUTHENTICATOR_CLIENT_ID,
	redirectUri: process.env.VUE_APP_AUTHENTICATOR_REDIRECT_URI,
	responseType: `code`
});

router.beforeEach(
	isAuthenticated({
		authUri: new URL(`${process.env.VUE_APP_API_URI}/authenticator`),
		loginUri: new URL(`${process.env.VUE_APP_AUTHENTICATOR_UI_URI}?${authSearchParams.toString()}`),
		store
	})
);

router.beforeEach(() => {
	if (!store.getters[`auth/user`].isEmailVerified) {
		window.location.assign(
			new URL(`${process.env.VUE_APP_AUTHENTICATOR_UI_URI}/verify-email`)
		);

		return false;
	}
});

router.beforeEach(dispatchByParam({
	clubId: `club/getById`,
	competitionId: `competition/getById`,
	membershipId: `membership/getById`
}));

router.beforeEach(getClubForParam({
	competitionId: `competition/getById`,
	membershipId: `membership/getById`
}));

router.beforeEach(isAuthorized());

export { router };
